import { Box, HStack, Stack } from "@chakra-ui/react"
import { Select, Text } from "./"

export interface SelectOption {
  value: string
  label: string
}

interface SelectFieldProps {
  label: string
  value: string
  options: SelectOption[]
  required?: boolean
  name?: string
  hint?: string
  error?: string
  onChange: (v: string) => void
}

// Labelled <select> matching TextField's layout (label row + control + hint/error)
// so mixed forms line up.
export const SelectField = ({
  label,
  value,
  options,
  required,
  name,
  hint,
  error,
  onChange,
}: SelectFieldProps) => (
  <Stack w="100%" gap={1}>
    <HStack gap={1}>
      <Text fontSize="sm" fontWeight="bold">{label}</Text>
      {required && <Box w="6px" h="6px" bg="red.500" borderRadius="full" mt="2px" />}
    </HStack>
    <Select
      value={value}
      name={name}
      aria-invalid={error ? true : undefined}
      borderColor={error ? "red.500" : undefined}
      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </Select>
    {error ? (
      <Text fontSize="xs" color="red.600">{error}</Text>
    ) : hint ? (
      <Text fontSize="xs" color="gray.500">{hint}</Text>
    ) : null}
  </Stack>
)
